import { z } from "zod";

import { createEnv } from "@t3-oss/env-nextjs";

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
export const env = createEnv({
    /**
     * Specify your server-side environment variables schema here. This way you can ensure the app
     * isn't built with invalid env vars.
     */
    server: {
        NODE_ENV: z.enum(["development", "test", "production"]),
        CF_CDA_TOKEN: z.string(),
        CF_CPA_TOKEN: z.string(),
        CF_CPS_TOKEN: z.string(),
        CF_CMA_TOKEN: z.string(),
        CF_BEARER_TOKEN: z.string(),
        CF_SPACE_ID: z.string(),
        CF_ENV: z.enum(["development", "master", "daniel", "sasha"]),

        SITE_PASSWORD: z.string().optional(),
        SITE_USERNAME: z.string().optional(),
        SITE_HOST: z.string(),
        SITE_CONTACT_EMAIL: z.string(),
        SITE_CONTACT_PASSWORD: z.string(),
        SITE_CONTACT_HOST: z.string(),
        SITE_CONTACT_PORT: z.string(),
        SITE_CONTACT_SECURE: z.boolean(),
        SITE_SHOP_HOST: z.string(),

        RAABITS_FRONTEND_URI: z.string(),
        RAABITS_BACKEND_URI: z.string(),
        RAABITS_AZURE_STORAGE_ACCOUNT_ENDPOINT: z.string(),
        RAABITS_AZURE_STORAGE_CONTAINER_NAME: z.string(),
        RAABITS_BEITRAG_IMAGE_CACHE_CONTROL_MAX_AGE: z.number(),
        RAABITS_CF_CDA_TOKEN: z.string(),
        RAABITS_CF_SPACE_ID: z.string(),
        RAABITS_CF_ENVIRONMENT: z.string(),
        RAABITS_CF_REVALIDATE_SECRET: z.string(),
        RAABITS_AZURE_TENANT_ID: z.string(),
        RAABITS_AZURE_CLIENT_ID: z.string(),
        RAABITS_AZURE_CLIENT_SECRET: z.string(),
        RAABITS_AZURE_SCOPE: z.string(),

        RECAPTCHA_SECRET_KEY: z.string(),

        INXMAIL_USERNAME: z.string(),
        INXMAIL_PASSWORD: z.string(),
        INXMAIL_CUSTOMER: z.string(),
    },

    /**
     * Specify your client-side environment variables schema here. This way you can ensure the app
     * isn't built with invalid env vars. To expose them to the client, prefix them with
     * `NEXT_PUBLIC_`.
     */
    client: {
        NEXT_PUBLIC_RECAPTCHA_KEY: z.string(),
        NEXT_PUBLIC_USE_TESTDATA: z.boolean().optional(),
    },

    /**
     * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
     * middlewares) or client-side so we need to destruct manually.
     */
    runtimeEnv: {
        NODE_ENV: process.env.NODE_ENV,

        CF_CDA_TOKEN: process.env.CF_CDA_TOKEN,
        CF_CPA_TOKEN: process.env.CF_CPA_TOKEN,
        CF_CPS_TOKEN: process.env.CF_CPS_TOKEN,
        CF_CMA_TOKEN: process.env.CF_CMA_TOKEN,
        CF_BEARER_TOKEN: process.env.CF_BEARER_TOKEN,
        CF_SPACE_ID: process.env.CF_SPACE_ID,
        CF_ENV: process.env.CF_ENV,

        SITE_PASSWORD: process.env.SITE_PASSWORD,
        SITE_USERNAME: process.env.SITE_USERNAME,
        SITE_HOST: process.env.SITE_HOST,
        SITE_CONTACT_EMAIL: process.env.SITE_CONTACT_EMAIL,
        SITE_CONTACT_PASSWORD: process.env.SITE_CONTACT_PASSWORD,
        SITE_CONTACT_HOST: process.env.SITE_CONTACT_HOST,
        SITE_CONTACT_PORT: process.env.SITE_CONTACT_PORT,
        SITE_CONTACT_SECURE: process.env.SITE_CONTACT_SECURE === "true",
        SITE_SHOP_HOST: process.env.SITE_SHOP_HOST,

        RAABITS_FRONTEND_URI: process.env.RAABITS_FRONTEND_URI,
        RAABITS_BACKEND_URI: process.env.RAABITS_BACKEND_URI,
        RAABITS_AZURE_STORAGE_ACCOUNT_ENDPOINT: process.env.RAABITS_AZURE_STORAGE_ACCOUNT_ENDPOINT,
        RAABITS_AZURE_STORAGE_CONTAINER_NAME: process.env.RAABITS_AZURE_STORAGE_CONTAINER_NAME,
        RAABITS_BEITRAG_IMAGE_CACHE_CONTROL_MAX_AGE: Number(
            process.env.RAABITS_BEITRAG_IMAGE_CACHE_CONTROL_MAX_AGE,
        ),
        RAABITS_CF_CDA_TOKEN: process.env.RAABITS_CF_CDA_TOKEN,
        RAABITS_CF_SPACE_ID: process.env.RAABITS_CF_SPACE_ID,
        RAABITS_CF_ENVIRONMENT: process.env.RAABITS_CF_ENVIRONMENT,
        RAABITS_CF_REVALIDATE_SECRET: process.env.RAABITS_CF_REVALIDATE_SECRET,
        RAABITS_AZURE_TENANT_ID: process.env.RAABITS_AZURE_TENANT_ID,
        RAABITS_AZURE_CLIENT_ID: process.env.RAABITS_AZURE_CLIENT_ID,
        RAABITS_AZURE_CLIENT_SECRET: process.env.RAABITS_AZURE_CLIENT_SECRET,
        RAABITS_AZURE_SCOPE: process.env.RAABITS_AZURE_SCOPE,

        RECAPTCHA_SECRET_KEY: process.env.RECAPTCHA_SECRET_KEY,
        NEXT_PUBLIC_RECAPTCHA_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_KEY,
        NEXT_PUBLIC_USE_TESTDATA: process.env.NEXT_PUBLIC_USE_TESTDATA === "true",

        INXMAIL_USERNAME: process.env.INXMAIL_USERNAME,
        INXMAIL_PASSWORD: process.env.INXMAIL_PASSWORD,
        INXMAIL_CUSTOMER: process.env.INXMAIL_CUSTOMER,
    },
    /**
     * Run `build` or `dev` with `SKIP_ENV_VALIDATION` to skip env validation. This is especially
     * useful for Docker builds.
     */
    skipValidation: !!process.env.SKIP_ENV_VALIDATION,
    /**
     * Makes it so that empty strings are treated as undefined. `SOME_VAR: z.string()` and
     * `SOME_VAR=''` will throw an error.
     */
    emptyStringAsUndefined: true,
});
